import { autoinject, bindable, bindingMode } from 'aurelia-framework';
import { ObjectHelper } from 'Code/Helpers/ObjectHelper';
import { BaseCustomElement } from 'Common/BaseCustomElement';

@autoinject
export class StornoBaseCustomElement extends BaseCustomElement {
}